// extracted by mini-css-extract-plugin
export default {"container":"Router_container__2LbAN","header":"Router_header__CP0LN","main":"Router_main__hH2YV"};